import { createStore, createEvent } from "effector"

import Message, { IMessage } from "models/Message"
import i18n from "intl/i18n"

const show = createEvent<IMessage>()
const hide = createEvent<IMessage>()
const showSystemError = createEvent<Partial<IMessage> | void>()
const showSyncFailed = createEvent<Partial<IMessage> | void>()
const showDataSaved = createEvent<Partial<IMessage> | void>()
const showDataUpdated = createEvent<Partial<IMessage> | void>()
const showDataDeleted = createEvent<Partial<IMessage> | void>()

const list = createStore<IMessage[]>([])

list.on(show, (state, message) => {
    return [
        ...state,
        new Message(message)
    ]
})

list.on(showSystemError, (state, message = {}) => {
    return [
        ...state,
        new Message({
            title: i18n.t("message.systemError"),
            type: "error",
            ...message
        })
    ]
})

list.on(showSyncFailed, (state, message = {}) => {
    return [
        ...state,
        new Message({
            title: i18n.t("message.syncFailed"),
            type: "error",
            duration: 0,
            ...message
        })
    ]
})

list.on(showDataSaved, (state, message = {}) => {
    return [
        ...state,
        new Message({
            title: i18n.t("message.dataSaved"),
            type: "default",
            ...message
        })
    ]
})

list.on(showDataUpdated, (state, message = {}) => {
    return [
        ...state,
        new Message({
            title: i18n.t("message.dataUpdated"),
            type: "default",
            ...message
        })
    ]
})


list.on(showDataDeleted, (state, message = {}) => {
    return [
        ...state,
        new Message({
            title: i18n.t("message.dataDeleted"),
            type: "default",
            ...message
        })
    ]
})


list.on(hide, (state, message) => {
    return state
        .filter(toastMessage => toastMessage !== message)
})

export default {
    show,
    showSystemError,
    showSyncFailed,
    showDataSaved,
    showDataUpdated,
    showDataDeleted,
    hide,
    list,
}
